import React from 'react'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import TextField from '@material-ui/core/TextField'
import { useController } from 'react-hook-form'
import DateFnsUtils from '@date-io/date-fns'
import locale_en from 'date-fns/locale/en-US'
import locale_fi from 'date-fns/locale/fi'
import locale_et from 'date-fns/locale/et'
import ClearIcon from '@material-ui/icons/Clear'
import { CalendarIcon } from '@mui/x-date-pickers'
import { withStyles, IconButton } from '@material-ui/core'
import { useSelector } from 'react-redux'

const styles = () => ({
  clearFieldButton: {
    // position: 'absolute',
    marginLeft: '-36px',
    marginRight: '4px',
    alignSelf: 'flex-end',
    marginTop: '49px',
    height: '32px',
    width: '32px'
  },
  clearIcon: {
    height: '18px',
    width: '18px'
  },
  calendarFieldButton: {
    position: 'absolutem',
    marginLeft: '-36px',
    marginRight: '4px',
    marginBottom: '2px',
    alignSelf: 'flex-end',
    height: '32px',
    width: '32px'
  },
  calendarIcon: {
    height: '18px',
    width: '18px'
  }
})

// Helper function to get locale based on language
export const getLocaleByLang = (lang) => {
  switch (lang) {
    case 'en':
      return locale_en
    case 'fi':
      return locale_fi
    case 'est':
      return locale_et
    default:
      return locale_en
  }
}

const DatePickerField = ({
  classes,
  name,
  control,
  defaultValue = new Date(),
  label,
  helperTextStyle,
  className,
  disabled = false,
  minDate,
  maxDate,
  onChange,
  disablePast = false,
  disableFuture = false,
  clearable,
  onClear,
  hidden = false,
  labelStyle,
  showCalendarIcon,
  showPlaceholder
}) => {
  const {
    field,
    fieldState: { invalid, error }
  } = useController({
    name,
    control,
    defaultValue: defaultValue
  })

  const lang = useSelector((state) => state.language.lang)
  const locale = React.useMemo(() => getLocaleByLang(lang), [lang]) // Dynamically set locale

  const [open, setOpen] = React.useState(false)

  const handleChange = (e) => {
    onChange?.(e)
    field.onChange(e)
  }

  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
        <DatePicker
          open={open}
          onOpen={() => setOpen(true)}
          name={name}
          label={label}
          value={field.value}
          inputRef={field.ref}
          onChange={handleChange}
          minDate={minDate}
          maxDate={maxDate}
          error={invalid}
          helperText={error}
          format={'dd.MM.yyyy'}
          disablePast={disablePast}
          disableFuture={disableFuture}
          disabled={disabled}
          onClose={() => {
            field.onBlur()
            setOpen(false)
          }}
          TextFieldComponent={(props) => (
            <TextField
              {...props}
              onBlur={() => field.onBlur()}
              InputProps={{
                classes: {
                  input: className
                },
                endAdornment: showCalendarIcon ? (
                  <IconButton className={classes.calendarFieldButton}>
                    <CalendarIcon className={classes.calendarIcon} />
                  </IconButton>
                ) : (
                  ''
                )
              }}
              value={disabled && showPlaceholder ? '--.--.----' : props.value}
            />
          )}
          InputProps={{
            classes: {
              input: className
            }
          }}
          InputLabelProps={{
            shrink: false,
            style: {
              fontSize: '15px',
              ...labelStyle
            }
          }}
          FormHelperTextProps={{
            style: {
              ...helperTextStyle
            }
          }}
          style={hidden ? { display: 'none' } : {}}
        />
      </MuiPickersUtilsProvider>
      {clearable && field.value !== null ? (
        <IconButton onClick={onClear} className={classes.clearFieldButton}>
          <ClearIcon className={classes.clearIcon} />
        </IconButton>
      ) : null}
    </>
  )
}

export const HookDatePicker = withStyles(styles)(DatePickerField)
